<style lang="stylus">
    .revisions
        .BaseSet-container
            padding 0px
        .vip-icon
            margin-left 8px
    .revisions-bacth
        display flex
        justify-content space-between
        align-items center
        margin 0 20px
        height 50px
        .disabled
            opacity 0.4
            filter grayscale(1)
            cursor not-allowed
            pointer-events none
        .bacth-left
            display flex
            align-items center
            cursor pointer
            .create-icon
                width 20px
                height 20px
                color var(--svg-color-gray-42)
            >span
                font-size 12px
                width 72px
                text-overflow ellipsis
                overflow hidden
                white-space nowrap
        .actionOption
            .ivu-select-selection
                background-color transparent;
            .ivu-select-dropdown
                left unset !important
                right 20px

    .revisions-panel
        position relative
        background-color $right-view-backcolor
        overflow-x hidden
        height calc(100% - 50px)
        overflow-y auto
        .revisions-item
            position relative
            padding 0 20px
            cursor pointer
            &:not(.ban-hover):hover
                background-color var(--hover-color-common)
                .item-tiny-icon
                    display block !important

            &:hover .revisions-icon
                visibility visible

            .revision-border
                width 100%
                height 1px
                border-top 1px solid var(--border-color-left-panel)

            .revisions-item-name
                position relative
                z-index 1
                height 38px
                padding-top 14px
                font-size 12px
                font-weight bold
                display flex
                justify-content space-between
                align-items center
                .rename-input
                    height 24px
                    width 96px
                    font-size 12px
                    border-radius 6px
                    padding-left 8px
                    border 1px solid var(--themeColor)
                    &:focus
                        outline none
                        border 1px solid var(--themeColor)
                .ivu-dropdown-item
                    font-size 12px
                    font-weight normal
                    width 100px
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                span
                    display inline-block
                    width 72px
                    font-size 12px
                    text-overflow ellipsis
                    white-space nowrap
                    overflow hidden

                .item-tiny-icon
                    display none
                    width 14px
                    height 14px
                    color var(--svg-color-gray-42)
                .item-icon
                    width 24px
                    height 24px
                    &.active
                        border-radius: 4px;
                        svg
                            background: var(--color-black-6);
                    svg
                        width 24px;
                        height 24px;
                        color var(--svg-color-gray-75)
                .ivu-dropdown-rel
                    font-size 0
            .revisions-item-img
                position relative
                top 3px
                .item-icon
                    svg
                        color var(--svg-color-history-more)
                .revisions-dropdown
                    position absolute
                    top 24px
                    right 0px
                    padding: 6px;
                    background: var(--bg-color-tertiary);
                    box-shadow: $box-shadow;
                    border-radius: 8px;
                    .dropdown-item
                        height 32px
                        display flex
                        align-items center
                        font-weight normal
                        max-width: 154px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        line-height: normal;
                        padding: 7.5px 10px;
                        clear: both;
                        color: var(--text-color-primary);
                        font-size: 12px!important;
                        cursor: pointer;
                        border-radius 6px
                        &:hover
                            background: var(--hover-color-common);
            .revisions-item-time
                font-size 12px
                margin-top 8px
                padding-bottom 16px

            .revisions-img-box
                position relative
                .img-item
                    display block
                    width 100%
                    min-height 136px
                    margin-top 8px
                    background var(--bg-color-primary)
                    border 1px solid var(--border-color-left-panel)
                    border-radius 6px
                .img-vip
                    display none
                    position absolute
                    margin-left 0
                    top 6px
                    right 5px
                .img-tag
                    display none
                    position absolute
                    left 0
                    top 0
                    background: linear-gradient(92.45deg, #CBCED7 0%, #ADB3C2 100%)
                    border-radius 6px 0
                    font-size 12px
                    line-height 12px
                    color #fff
                    padding 4px 8px
                &:hover
                    .img-vip,
                    .img-tag
                        display block
            .revisions-icon
                position absolute
                visibility hidden
                top 0
                right 25px
                width 16px
                height 16px
                i
                    position absolute
                    top 3px
            .revisions-del
                right 0px
        .revisions-tips
            display flex
            flex-direction column
            justify-content center
            align-items center
            text-align center
            position absolute
            left 0
            right 0
            top -20%
            bottom 0
            margin auto
            font-size 12px
            line-height 16px
            .nonVip-box
                max-width 175px
                color #222222
                margin-top 24px
                .toVip-tips
                    cursor pointer
                    color $vip-test-color
                    &:hover
                        text-decoration underline
        .active
            background-color var(--bg-color-right-menu-history-item-active) !important
            .revision-border
                border-color var(--border-color-right-panel-item-dropbox)
</style>

<template>
    <setbox :setTitle="$t('Revisions.title')" class="revisions">
        <div class="revisions-bacth">
            <div class="bacth-left" @click="manualSave" :class="handClass">
                <iconSymbol class="create-icon" name="mm-centerTopic"></iconSymbol>
                <span :title="$t('Revisions.create')">{{ $t("Revisions.create") }}</span>
                <VipIcon v-if="!vip" />
            </div>

            <i-select v-model="action" size="small" class="actionOption" :class="handClass" @on-change="changeAction">
                <i-option v-for="item in actionModel" :title="item.label" :value="item.value" :key="item.value">{{ item.label }}</i-option>
            </i-select>
        </div>
        <div class="revisions-panel">
            <template v-show="revisionsList.length > 0">
                <div
                    class="revisions-item"
                    :class="{ active: activeRevision(item) && showOption != index, 'ban-hover': showOption == index }"
                    v-for="(item, index) in revisionsList"
                    :key="index"
                    @dblclick="dblClickItem(item, index)"
                    @click="select(item)"
                >
                    <div class="revision-border"></div>
                    <div class="revisions-item-name">
                        <div style="display: flex; align-items: center">
                            <span v-if="EditState != index" :title="item.name">{{ item.name }}</span>
                            <input
                                maxlength="20"
                                class="rename-input"
                                type="text"
                                v-if="EditState == index"
                                v-model="Rename"
                                autofocus="autofocus"
                                :ref="'rename_' + index"
                                @blur="changeName(index, item)"
                                @keypress.enter="keyEnter(index, item)"
                            />
                            <div @click.stop="editName(index, item)" v-if="EditState != index">
                                <iconSymbol style="margin-left: 8px" class="item-tiny-icon" name="editLayer" />
                            </div>
                        </div>

                        <div class="revisions-item-img">
                            <span
                                class="item-icon"
                                :class="{ active: activeRevision(item) && showOption == index }"
                                @click.stop="toShowOption(index, item)"
                                v-click-outside="() => (showOption = -1)"
                            >
                                <iconSymbol name="right-revisions-more" />
                            </span>
                            <div class="revisions-dropdown" v-show="showOption == index">
                                <div
                                    class="dropdown-item"
                                    v-if="!isTeamsApp"
                                    :title="$t('Revisions.createPage')"
                                    @click="toHandler('create', item, index)"
                                >
                                    <span>{{ $t("Revisions.createPage") }}</span>
                                    <VipIcon v-if="!vip && item.showVip" />
                                </div>
                                <div class="dropdown-item" :title="$t('Revisions.open')" @click="toHandler('refresh', item, index)">
                                    <span>{{ $t("Revisions.open") }}</span>
                                    <VipIcon v-if="!vip && item.showVip" />
                                </div>
                                <div class="dropdown-item" :title="$t('Revisions.delete')" @click="toHandler('trash', item, index)">
                                    <span>{{ $t("Revisions.delete") }}</span>
                                    <VipIcon v-if="!vip && item.showVip" />
                                </div>
                            </div>
                        </div>
                        <!-- <div class="revisions-icon revisions-del" :content="$t('trash')" v-tippy="{ placement : 'bottom-end' }">
                            <Icon type="md-trash" />
                        </div>
                        <div class="revisions-icon" @click="open(index)" :content="$t('refresh')" v-tippy="{ placement : 'bottom-end' }">
                            <Icon type="md-refresh" />
                        </div> -->
                    </div>
                    <div class="revisions-img-box">
                        <VipIcon v-if="!vip && item.showVip" class="img-vip" />
                        <img class="img-item" :src="revisionImg(item.img, item.exp, item.img_sign)" />
                        <div v-if="!EDCONFIG.IS_SDK" class="img-tag">{{ $t("expireDate", { date: getRestTime(item.created_at) }) }}</div>
                    </div>
                    <!-- <div class="revisions-item-time">{{item.description}}</div> -->
                    <div class="revisions-item-time">{{ getTime(item.created_at) }}</div>
                </div>
            </template>
            <div class="revisions-tips" v-if="revisionsList.length == 0">
                <img src="@/app/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("emptyRevisions") }}</span>
                <div class="nonVip-box" v-if="!vip" v-html="$t('toVipTips')" @click.prevent="toVip($event)"></div>
            </div>
        </div>
    </setbox>
</template>

<script lang="ts">
    declare var EDLayer: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import setbox from "./BaseSet.vue";
    import cloneDeep from "lodash/cloneDeep";
    import remove from "lodash/remove";
    import last from "lodash/last";
    @Component({
        components: {
            setbox,
        },
    })
    export default class Layers extends Vue {
        toVip(e) {
            e.target.tagName == "SPAN" && this.$openBuyPage("versionText");
        }
        revisionImg(img, exp, sign) {
            if (window.EDCONFIG.IS_SDK) {
                return img;
            }
            if (this.isPrivate) {
                return `${window["GLOBAL"].PRIVATE_OSS_HOST}${img}?${sign}`;
            }
            return this.internal
                ? `${window["GLOBAL"].PRIVATE_OSS_HOST}${img}?OSSAccessKeyId=${this.OSSAccessKeyId}&Expires=${exp}&Signature=${encodeURIComponent(
                      sign
                  )}`
                : `${window["GLOBAL"].PRIVATE_OSS_HOST}${img}?${sign}`;
        }

        get shareUUID() {
            return this.$store.state.ui.shareUUID;
        }
        get editTeamOption() {
            return this.$store.state.ui.editTeamOption;
        }

        get handClass() {
            return this.shareUUID || this.editTeamOption ? "disabled" : "";
        }

        activeRevision(item) {
            if (this.isPrivate) {
                return this.revisionfileKey == item.ver_file_key;
            } else {
                return this.selectId == item.id;
            }
        }
        getTime(timeStamp: number) {
            return (<any>new Date(timeStamp * 1000)).format("yyyy-MM-dd HH:mm:ss");
        }
        getRestTime(timeStamp: number) {
            let target = new Date(timeStamp * 1000).getDate() + 30,
                now = new Date().getDate();
            return target - now;
        }

        getVersionList(obj) {
            this.$store.dispatch("getVersionList", { obj }).then((res) => {});
        }

        get userInfo() {
            return this.$store.state.user.userInfo;
        }

        get actionModel() {
            return [
                {
                    label: this.$t("Revisions.all"),
                    value: 2,
                },
                {
                    label: this.$t("Revisions.auto"),
                    value: 1,
                },
                {
                    label: this.$t("Revisions.manual"),
                    value: 0,
                },
            ];
        }
        action = 2;
        // 筛选不同的保存类型
        get revisionsList() {
            let revisionList = this.$store.state.version.revisionsList;
            if (this.action !== 2) {
                revisionList = revisionList.filter((item) => item.auto === this.action);
            }
            let autoSaveNum = 0;
            revisionList.forEach((item) => {
                autoSaveNum++;
                if (item.auto == 1 && autoSaveNum > 2) {
                    item["showVip"] = true;
                }
            });
            return revisionList;
        }

        get revisionsLists() {
            return this.$store.state.version.revisionsList;
        }
        getversionName(initId: number): string {
            let prefix = this.lang == "zh" ? "手动保存" : "Manual Save";
            const revisions = this.revisionsLists.filter((item) => item.auto == 0);

            let id = initId || revisions.length + 1;
            let name: string = `${prefix}-${id}`;
            while (revisions.find((item) => item.name === name)) {
                id++;
                name = `${prefix}-${id}`;
            }
            return name;
        }
        doing = false;
        // 手动保存历史版本
        manualSave() {
            if (!this.vip) {
                this.$openBuyPage("versionCreate");
                return;
            }
            if (this.doing) return;
            this.doing = true;

            const revisionsLists = cloneDeep(this.revisionsLists);
            const data = this.revisionsLists.filter((item) => item.auto === 0);
            let initId;
            if (data.length === 15) {
                this.$store.commit("setVersionState", {
                    type: "revisionsList",
                    data: remove(this.revisionsLists, (v) => v.id !== last(data).id),
                });
                initId = 1;
            }

            this.$store
                .dispatch("saveVersion", {
                    file_key: this.$store.state.ui.fileKey,
                    urlSearch: this.$store.state.ui.fileInfo,
                    versionDes: this.$t("versionDes"),
                    auto: 0,
                    name: this.getversionName(initId),
                })
                .then(() => {
                    this.$nextTick(() => {
                        if (!window.EDCONFIG.IS_SDK && this.action !== 1) {
                            const index = this.revisionsLists.findIndex((item) => item.auto === 0);
                            this.editName(index, this.revisionsLists[index]);
                        }
                        this.doing = false;
                    });
                    this.sensors.track("clickCreatHistoricalVersion", {
                        Catalogues: "historicalVersion",
                        result: "success",
                    });
                })
                .catch(() => {
                    this.$edMessage.error(this.$t("loadFailed"));
                    this.$store.commit("setVersionState", {
                        type: "revisionsList",
                        data: revisionsLists,
                    });
                    this.doing = false;
                    this.sensors.track("clickCreatHistoricalVersion", {
                        Catalogues: "historicalVersion",
                        result: "failure",
                    });
                });
        }
        // 当前选中
        get selectId() {
            return this.$store.state.version.selectId;
        }

        set selectId(v) {
            this.$store.commit("setVersionState", {
                type: "selectId",
                data: v,
            });
        }

        get revisionfileKey() {
            return this.$store.state.version.revisionfileKey;
        }

        set revisionfileKey(v) {
            this.$store.commit("setVersionState", {
                type: "revisionfileKey",
                data: v,
            });
        }

        select(item) {
            console.log(this.revisionsList);
            this.selectId = item.id;
            this.revisionfileKey = item.ver_file_key;
        }
        changeAction() {
            let type = ["historicalVersionall", "autosave", "manualGeneration"][this.action];
            this.sensors.track("clickFilterItem", {
                Catalogues: "historicalVersion",
                type,
            });
        }

        dblClickItem(item, index) {
            this.sensors.track("popupMenu", {
                Catalogues: "historicalVersion",
                type: "doubleClickFile",
            });
            this.toHandler("open", item, index);
        }
        // 本版历史项下拉菜单
        toHandler(name, item, index) {
            const trackObj = {
                create: "versionNew",
                refresh: "versionRecover",
                trash: "versionDelete",
                open: "versionOpen",
            };
            const triggerName = trackObj[name];
            if (!(this.vip || this.isPrivate) && item.showVip) {
                this.$openBuyPage(triggerName);
                return;
            }
            if (name == "open") {
                name = "refresh";
            }
            const map = new Map([
                [
                    "create",
                    () => {
                        this.openNewPage(item);
                        this.sensors.track("clickHistoricalFileOperation", {
                            Catalogues: "historicalVersion",
                            type: "newFile",
                        });
                    },
                ],
                [
                    "refresh",
                    () => {
                        this.open(index);
                        this.sensors.track("clickHistoricalFileOperation", {
                            Catalogues: "historicalVersion",
                            type: "recovery",
                        });
                        this.sensors.track("popupMenu", {
                            Catalogues: "historicalVersion",
                            type: "menubutton",
                        });
                    },
                ],
                // ["rename",()=>{}],
                [
                    "trash",
                    () => {
                        this.delVisions(item, index);
                        this.sensors.track("clickHistoricalFileOperation", {
                            Catalogues: "historicalVersion",
                            type: "delete",
                        });
                    },
                ],
            ]);
            map.get(name)();
        }

        // 修改名称

        EditState = -1;
        showOption = -1;
        Rename = "";
        changeName(index, item) {
            this.EditState = -1;
            if (item.name === this.Rename || !this.Rename) return;
            const value = this.revisionsLists.find((item) => item.name === this.Rename);
            if (value && value.name) {
                this.Rename = `${this.Rename}_1`;
            }
            let params = {
                version_id: item.id,
                name: this.Rename,
                token: this.userInfo.token,
                id: this.userInfo.user_id,
            };
            if (this.isPrivate) {
                Object.assign(params, {
                    file_key: item.file_key,
                    ver_file_key: item.ver_file_key,
                });
            }
            this.$edApi.editVersion(params).then((res) => {
                this.revisionsLists.find((r) => r.id === item.id).name = this.Rename;
            });
        }

        keyEnter(index, item) {
            this.$refs["rename_" + index][0].blur();
        }
        editName(index, item) {
            this.EditState = index;
            this.Rename = item.name;
            setTimeout(() => {
                this.$refs["rename_" + index][0].focus();
            }, 0);
            this.sensors.track("rename", {
                Catalogues: "historicalVersion",
            });
        }
        toShowOption(index, item) {
            this.select(item);
            if (index === this.showOption) {
                this.showOption = -1;
                return;
            }
            this.showOption = index;
        }

        delVisions(item, index) {
            this.$track("rightPanel", "history", "delete history");
            this.$store.commit("setVersionState", {
                type: "VersionTipType",
                data: "del",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "VersionTip",
            });
        }

        open(index) {
            this.$track("rightPanel", "history", "double click history");
            this.$store.commit("setVersionState", {
                type: "VersionTipType",
                data: "open",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "VersionTip",
            });
        }
        openNewPage(item) {
            let ts: any = this;
            let params = {
                version_id: item.id,
                token: this.userInfo.token,
                id: this.userInfo.user_id,
            };
            if (this.isPrivate) {
                Object.assign(params, {
                    file_key: item.file_key,
                    ver_file_key: item.ver_file_key,
                });
            }

            if (window.EDCONFIG.IS_SDK) {
                this.sdkApp.promisePostMessage("GET_VERSION_COPY", { version_id: item.id });
                return;
            }

            this.$edApi.versionToNew(params).then((data) => {
                let fileKey = data.obj + `&name=${data.name || "历史版本"}`;
                window.open(window.location.href.replace(/(.*\/)*(\?[^.]+).*/gi, "$1") + "?" + ts.$zipFileName("obj=" + fileKey));
            });
        }
        mounted() {
            this.$bus.$on("beforeAutoSaveVersion", () => {
                this.EditState = -1;
            });
        }
        beforeDestroy() {
            this.$bus.$off("beforeAutoSaveVersion");
        }
        activated() {
            this.$bus.$emit("setRightViewTitle", "revisionSet");
        }
    }
</script>
<i18n>
{
  "zh": {
    "Revisions": {
      "title": "历史版本",
      "visionsName1": "第",
      "visionsName2": " 版",
      "create": "创建历史版本",
      "all": "全部",
      "manual": "手动保存",
      "auto": "自动保存",
      "createPage": "新建此版本",
      "open": "恢复至此版本",
      "delete": "删除此版本"
    },
    "emptyRevisions": "暂无记录",
    "toVipTips": "非会员仅支持打开前2个自动保存的版本，<span class='toVip-tips'>开通VIP解锁限制</span>",
    "nullTips": "手动保存文件后，自动生成历史版本",
    "trash": "删除此版本",
    "refresh": "恢复至此版本",
    "create": "新建此版本",
    "rename": "重命名",
    "loadFailed": "加载失败, 请重试",
    "versionDes": "描述",
    "expireDate": "{date}天后永久删除"
  },
  "en": {
    "Revisions": {
      "title": "Historical Version",
      "visionsName1": "The",
      "visionsName2": "version",
      "create": "Create historic file version",
      "all": "All",
      "manual": "Manual Save",
      "auto": "Automatic Save",
      "createPage": "Create this version",
      "open": "Revert to this version",
      "delete": "Delete this version"
    },
    "emptyRevisions": "No records available",
    "toVipTips": "With the Free version you can only open the last 2 autosaved versions. <span class='toVip-tips'>Upgrade to Premium for unlimited access.</span>",
    "nullTips": "After saving the file manually, the historical version will be generated automatically",
    "trash": "Delete",
    "refresh": "Recover",
    "loadFailed": "Loading failed, please ",
    "versionDes": "Description",
    "expireDate": "Permanently deleted after {date} days"
  },
  "fr": {
    "Revisions": {
      "title": "Version historique",
      "visionsName1": "la",
      "visionsName2": " Version ",
      "create": "Créer une version historique",
      "all": "Tout",
      "manual": "Enregistrer manuelle",
      "auto": "Enregistrer automatique",
      "createPage": "Créer cette version",
      "open": "Revenir à cette version",
      "delete": "Supprimer cette version"
    },
    "emptyRevisions": "Aucun enregistrement disponible",
    "toVipTips": "Avec la version gratuite, vous ne pouvez ouvrir que les deux dernières versions enregistrées automatiquement. <span class='toVip-tips'>Passez à la version Premium pour un accès illimité.</span>",
    "nullTips": "Après avoir enregistré manuellement le fichier, la version historique est automatiquement générée",
    "trash": "Supprimer cette version",
    "refresh": "Revenir à cette version",
    "loadFailed": "Le chargement a échoué, veuillez réessayer.",
    "versionDes": "Description",
    "expireDate": "Permanently deleted after {date} days"
  },
  "de": {
    "Revisions": {
      "title": "Historische Version",
      "visionsName1": "Die",
      "visionsName2": "Version",
      "create": "Erstellen Sie eine historische Version",
      "all": "Alle",
      "manual": "Manuelles Speichern",
      "auto": "Automatisches Speichern",
      "createPage": "Erstellen Sie diese Version",
      "open": "Kehren Sie zu dieser Version zurück",
      "delete": "Löschen Sie diese Version"
    },
    "emptyRevisions": "Keine Datensätze verfügbar",
    "toVipTips": "Mit der kostenlosen Version können Sie nur die letzten 2 automatisch gespeicherten Versionen öffnen.<span class='toVip-tips'>Führen Sie ein Upgrade auf Premium durch, um uneingeschränkten Zugriff zu genießen.</span>",
    "nullTips": "Nach dem manuellen Speichern der Datei wird die Verlaufsversion automatisch generiert",
    "trash": "Diese Version löschen",
    "refresh": "Zurück zu dieser Version",
    "loadFailed": "Hochladen fehlgeschlagen, bitte versuchen Sie später erneut ",
    "versionDes": "Beschreibung",
    "expireDate": "Permanently deleted after {date} days"
  },
  "jp": {
    "Revisions": {
      "title": "バージョン履歴",
      "visionsName1": "第",
      "visionsName2": "版",
      "create": "バージョンを作成する",
      "all": "すべて",
      "manual": "手動で保存",
      "auto": "自動で保存",
      "createPage": "新しいファイルとして作成",
      "open": "このバージョンを復元",
      "delete": "このバージョンを削除"
    },
    "emptyRevisions": "利用可能なレコードがありません",
    "toVipTips": "無料バージョンでは、自動保存された最後の 2 つのバージョンのみを開くことができます。<span class='toVip-tips'>無制限のアクセスを得るには、プレミアムにアップグレードしてください。</span>",
    "nullTips": "手動で保存した後、バージョンが自動的に生成されます。",
    "trash": "このバージョンを削除",
    "refresh": "このバージョンに戻す",
    "create": "新規作成",
    "rename": "名前を変更",
    "loadFailed": "読み込めませんでした。再度お試しください",
    "versionDes": "説明",
    "expireDate": "Permanently deleted after {date} days"
  },
  "es": {
    "Revisions": {
      "title": "Versión histórica",
      "visionsName1": "El",
      "visionsName2": "versión",
      "create": "Crea una versión histórica",
      "all": "Todo",
      "manual": "Guarda manualmente",
      "auto": "Guardado automático",
      "createPage": "Crea esta versión",
      "open": "Vuelve a esta versión",
      "delete": "Elimina esta versión"
    },
    "emptyRevisions": "No hay registros disponibles",
    "toVipTips": "Con la versión Gratis solo puede abrir las últimas 2 versiones guardadas automáticamente.<span class='toVip-tips'>Actualice a Premium para obtener acceso ilimitado.</span>",
    "nullTips": "Después de guardar el archivo manualmente, la versión histórica se generará automáticamente",
    "trash": "Eliminar",
    "refresh": "Recuperar",
    "loadFailed": "Error al cargar, inténtelo de nuevo",
    "versionDes": "Descripción",
    "expireDate": "Permanently deleted after {date} days"
  },
  "pt": {
    "Revisions": {
      "title": "Versão Histórica",
      "visionsName1": "A",
      "visionsName2": "versão",
      "create": "Crie versões históricas",
      "all": "Todos",
      "manual": "Salve manualmente",
      "auto": "Salvo automático",
      "createPage": "Crie esta versão",
      "open": "Volte a esta versão",
      "delete": "Delete esta versão"
    },
    "emptyRevisions": "Nenhum registro disponível",
    "toVipTips": "Com a versão gratuita, você só pode abrir as últimas 2 versões salvas automaticamente. <span class='toVip-tips'>Atualize para a versão Premium para ter acesso sem limites.</span>",
    "nullTips": "Após salvar manualmente o arquivo, a versão histórica é gerada automaticamente",
    "trash": "Excluir esta versão",
    "refresh": "Reverter para esta versão",
    "loadFailed": "Erro de carregamento. Por favor tente novamente",
    "versionDes": "Descrição",
    "expireDate": "Permanently deleted after {date} days"
  },
  "it": {
    "Revisions": {
      "title": "Cronologia Versioni",
      "visionsName1": "La",
      "visionsName2": "versione",
      "create": "crea una versione storica",
      "all": "tutto",
      "manual": "conserva manualmente",
      "auto": "conserva automaticamente",
      "createPage": "crea questa versione",
      "open": "ricupera a questa versione",
      "delete": "cancella questa versione"
    },
    "emptyRevisions": "Nessun record disponibile",
    "toVipTips": "Con la versione gratuita puoi aprire solo le ultime 2 versioni salvate automaticamente.<span class='toVip-tips'>Passa alla versione Premium per un accesso illimitato</span>",
    "nullTips": "Dopo aver salvato manualmente il file, viene generata automaticamente la versione storica",
    "trash": "Elimina questa versione",
    "refresh": "Torna a questa versione",
    "loadFailed": "Caricamento non riuscito, riprova",
    "versionDes": "Descrizione",
    "expireDate": "Permanently deleted after {date} days"
  },
  "tw": {
    "Revisions": {
      "title": "歷史版本",
      "visionsName1": "第",
      "visionsName2": " 版",
      "create": "建立歷史版本",
      "all": "全部",
      "manual": "手動儲存",
      "auto": "自動儲存",
      "createPage": "新建此版本",
      "open": "恢復至此版本",
      "delete": "刪除此版本"
    },
    "emptyRevisions": "沒有可用記錄",
    "toVipTips": "使用免費版本時，您只能開啟最後 2 個自動儲存的版本。<span class='toVip-tips'>升級至 Premium 以享有無上限的存取權限。</span>",
    "nullTips": "手動儲存檔案後，自動生成歷史版本",
    "trash": "刪除此版本",
    "refresh": "恢復至此版本",
    "create": "新建此版本",
    "rename": "重命名",
    "loadFailed": "加載失敗,請重試",
    "versionDes": "描述",
    "expireDate": "{date}天後永久刪除"
  },
  "kr": {
    "Revisions": {
      "title": "Historical Version",
      "visionsName1": "The",
      "visionsName2": "version",
      "create": "Create historic file version",
      "all": "All",
      "manual": "Manual Save",
      "auto": "Automatic Save",
      "createPage": "Create this version",
      "open": "Revert to this version",
      "delete": "Delete this version"
    },
    "emptyRevisions": "사용 가능한 레코드 없음",
    "toVipTips": "무료 버전을 사용하면 자동 저장된 마지막 2개 버전만 열 수 있습니다.<span class='toVip-tips'>프리미엄으로 업그레이드하여 무제한 액세스를 이용하십시오.</span>",
    "nullTips": "After saving the file manually, the historical version will be generated automatically",
    "trash": "Delete",
    "refresh": "Recover",
    "loadFailed": "Loading failed, please ",
    "versionDes": "Description",
    "expireDate": "Permanently deleted after {date} days"
  },
  "id": {
    "emptyRevisions": "Catatan tidak tersedia",
    "toVipTips": "Dengan versi Gratis ini, Anda hanya dapat membuka 2 versi yang disimpan otomatis terakhir.  <span class='toVip-tips'>Tingkatkan ke Premium untuk akses tak terbatas.</span>",
    "expireDate": "Permanently deleted after {date} days"
  }
}
</i18n>
